require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-inclusiveleadership.json") })
        }
      }, "path---insights-inclusiveleadership");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-inclusiveleadership!./.cache/json/insights-inclusiveleadership.json
// module id = 1134
// module chunks = 231608221292675